import React from 'react';
import {
  Alert,
  Box,
  Collapse,
  IconButton,
  Stack,
  Typography,
} from '@mui/material';
import { alpha } from '@mui/material/styles';
import HelpOutlineIcon from '@mui/icons-material/HelpOutline';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import ExpandLessIcon from '@mui/icons-material/ExpandLess';

const PIIAnonymizerHelp = ({ t }) => {
  const [open, setOpen] = React.useState(true);
  const collapseId = 'pii-anonymizer-help';

  return (
    <Alert
      icon={<HelpOutlineIcon sx={{ mt: 0.5 }} />}
      severity="info"
      variant="outlined"
      sx={{
        mb: 2,
        borderRadius: 2,
        '& .MuiAlert-message': { width: '100%' },
        py: 1.5,
        px: 2,
      }}
      action={
        <IconButton
          size="small"
          onClick={() => setOpen((v) => !v)}
          aria-expanded={open}
          aria-controls={collapseId}
          aria-label={open ? 'collapse' : 'expand'}
          sx={{ mt: 0.5, color: 'inherit' }}
        >
          {open ? <ExpandLessIcon fontSize="small" /> : <ExpandMoreIcon fontSize="small" />}
        </IconButton>
      }
    >
      <Typography variant="subtitle1" sx={{ fontWeight: 600, mb: 0.5 }}>
        {t?.('PIIAnonymizerPage.help.title', 'Ako to funguje')}
      </Typography>

      <Collapse in={open} timeout="auto" id={collapseId}>
        <Stack spacing={1.5} sx={{ mt: 1.5 }}>
          <Typography variant="body2" sx={{ lineHeight: 1.6 }}>
            {t?.(
              'PIIAnonymizerPage.help.p1',
              'Nahrajte jeden alebo viacero súborov, ktoré potrebujete anonymizovať.'
            )}
          </Typography>

          <Typography variant="body2" sx={{ lineHeight: 1.6 }}>
            {t?.(
              'PIIAnonymizerPage.help.p2',
              'Zvoľte profil, podľa ktorého sa má anonymizácia vykonať (napríklad ÚOUZ - úplný), alebo vyberte jeden z vašich privátnych profilov. Prípadne môžete údaje vybrať manuálne.'
            )}
          </Typography>

          <Typography variant="body2" sx={{ lineHeight: 1.6 }}>
            {t?.(
              'PIIAnonymizerPage.help.p3',
              'Po ukončení procesu si môžete všetky súbory stiahnuť do počítača. Neskôr ich nájdete v časti Moje súbory.'
            )}
          </Typography>

          <Box 
            sx={(theme) => ({ 
              mt: 1, 
              p: 1.5, 
              borderRadius: 1.5,
              border: '1px dashed',
              borderColor: 'info.main',
              bgcolor: alpha(theme.palette.info.main, 0.08)
            })}
          >
            <Typography variant="body2" sx={{ display: 'block', fontWeight: 600, color: 'info.main' }}>
              💡 {t?.('PIIAnonymizerPage.help.tipsTitle', 'Tipy')}
            </Typography>

            <Typography variant="body2" color="text.secondary" sx={{ mt: 0.5, lineHeight: 1.5 }}>
              • {t?.(
                'PIIAnonymizerPage.help.tip1',
                'Ak chcete vytvoriť profil anonymizácie podľa vašich špecifických požiadaviek, kliknite v menu na Anonymizačné profily a vytvorte si ho.'
              )}
            </Typography>

            <Typography variant="body2" color="text.secondary" sx={{ mt: 0.25, lineHeight: 1.5 }}>
              • {t?.(
                'PIIAnonymizerPage.help.tip2',
                'Potrebujete protokol o anonymizácii so zhrnutím upravených dát? Nájdete ho pri stiahnutom dokumente.'
              )}
            </Typography>
          </Box>
        </Stack>
      </Collapse>
    </Alert>
  );
};

export default PIIAnonymizerHelp;